/* eslint-disable react-refresh/only-export-components */

import { AxiosError } from "axios";
import type { CSSProperties, ReactNode } from "react";

/** Style d'input partagé par les écrans finance (cohérent avec le reste de l'admin). */
export const inputStyle: CSSProperties = {
	padding: "9px 12px",
	borderRadius: 8,
	border: "1px solid var(--a-border)",
	fontSize: 13,
	width: "100%",
	background: "var(--a-surface, #fff)",
};

export function Field({
	label,
	children,
	style,
}: {
	label: string;
	children: ReactNode;
	style?: CSSProperties;
}) {
	return (
		// biome-ignore lint/a11y/noLabelWithoutControl: Field wraps input control children
		<label style={{ display: "grid", gap: 4, ...style }}>
			<span className="muted" style={{ fontSize: 12 }}>
				{label}
			</span>
			{children}
		</label>
	);
}

/** Extrait un message d'erreur lisible d'une erreur API. */
export function apiError(e: unknown): string {
	if (e instanceof AxiosError) {
		const data = e.response?.data as
			| { message?: string | string[] }
			| undefined;
		const m = data?.message;
		if (Array.isArray(m)) return m.join(", ");
		if (m) return m;
	}
	return (e as Error)?.message ?? "Erreur inconnue";
}

export const VAT_OPTIONS = [
	{ value: 0.1925, label: "19,25 % (normal)" },
	{ value: 0.0975, label: "9,75 % (réduit)" },
	{ value: 0, label: "0 % (exonéré / export)" },
];
